import { render } from "./MainLayout.vue?vue&type=template&id=99a224b2&scoped=true"
import script from "./MainLayout.vue?vue&type=script&lang=js"
export * from "./MainLayout.vue?vue&type=script&lang=js"

import "./MainLayout.vue?vue&type=style&index=0&id=99a224b2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-99a224b2"

export default script